<template>
  <div id="contenedor-main-reportes">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4 d-print-none">
        <v-card-text>
          <titulo-tool-bar
            :titulo="getTituloVentana">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TituloToolBar from '@/components/TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainReportes',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  computed: {
    getTituloVentana() {
      return 'Consultas';
    },
  },
};
</script>

<style lang="scss">

</style>
